// /src/pdf/builders/listeners/buildDoc.js
export function buildListenersDoc({
  t, shortcode, stationName,
  startDate, endDate, startTime, endTime,
  country, rows, total, fmtNumber, locale,
  logoDataUrl, // ← необязательный dataURL логотипа (можно не передавать)
  serviceName
}) {
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('listeners.title')) || '';
  const hdr = [
    { text: t('listeners.table.hour'), style: 'th' },
    { text: t('listeners.table.listeners'), style: 'th', alignment: 'right' },
  ];

  const body = [
    hdr,
    ...(rows || []).map(r => ([
      { text: r.period ?? '', alignment: 'left' },
      { text: fmtNumber(r.total_listeners ?? 0, locale), alignment: 'right' },
    ])),
  ];

  const periodStr1 = `${t('listeners.from_date')}: ${startDate}  ${t('listeners.time_from')}: ${startTime || '00:00'}`;
  const periodStr2 = `${t('listeners.to_date')}: ${endDate}  ${t('listeners.time_to')}: ${endTime || '23:59'}`;
  const countryStr = country ? country : (t('listeners.all') || 'All');
  const madeOnText = (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net';

  // --- контент собираем по шагам, чтобы опционально вставить логотип
  const content = [];

  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, alignment: 'left', margin: [0, 0, 0, 10] });
  }

  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: [
        periodStr1,
        periodStr2,
        `${t('listeners.country')}: ${countryStr}`,
      ],
    },
    // ▼ ОБЯЗАТЕЛЬНАЯ подпись под «шапкой» (НЕ в колонтитуле)
    {
      text: madeOnText,
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10]
    },
    {
      table: {
        headerRows: 1,
        widths: ['*', 'auto'],
        body,
      },
      layout: {
        fillColor: (rowIndex) => (rowIndex === 0 ? '#f0f0f0' : null),
        hLineColor: '#e0e0e0',
        vLineColor: '#e0e0e0',
      },
    },
  );

  if (typeof total === 'number') {
    content.push({
      margin: [0, 8, 0, 0],
      columns: [
        {
          text: t('listeners.total', {
            count: total ?? 0,
            value: fmtNumber(total ?? 0, locale)
          }),
          style: 'totalValue',
          alignment: 'right'
        }
      ]
    });
  }

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${madeOnText} • ${new Date().toLocaleString()}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
      th: { bold: true },
      totalValue: { fontSize: 12, bold: true },
    },
  };
}

export { buildListenersDoc as default };
